<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
    <div class="containerBox" id="toTop">
    <div class="headerBox">
      <div class="top">
        <div class="searchBox" @click.stop="$router.push('/search')">
          <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
          <span class="searchInput">请输入关键字搜索</span>
        </div>
      </div>
      <div class="classify">
        <div class="classify_content" ref="wrapper">
          <div class="classify_wrapper">
            <span class="active_classify">
              <template v-if="userInfo.Type != 3">全部</template>
              <template v-if="userInfo.Type == 3">ALL</template>
            </span>
            <span v-for="(item, index) in navBar" :key="index" @click="toDepartment(item.Id, item.Code, item.TCode, item.DisplayName)">{{item.DisplayName}}</span>
          </div>
        </div>
        <div class="more">
          <router-link to="/interest">
            <img class="addIcon" src="@/assets/images/ellipsis.png" />
            <span>{{userInfo.Type != 3 ? '更多科室' : 'More'}}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="banner" v-if="bannerList.length > 0">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#CA001B">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="imgclick(item)">
            <img class="bannerImg" :src="item.File_Url" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="liveBox">
        <div class="screenBox">
          <div class="screenBtn">
            <template v-if="userInfo.Type != 3">活动日历</template>
            <template v-if="userInfo.Type == 3">Calendar</template>
          </div>
          <!-- <div class="screenBtn" @click="showScreen">
            <span>科室筛选</span>
            <img src="@/assets/images/screen.png" />
          </div> -->
          <van-popup v-model="showScreenPopover" round position="bottom" :style="{ height: '50%' }">
            <div class="pickerContent">
              <div class="van-picker__toolbar toolbar">
                <button type="button" class="van-picker__cancel" @click="onScreenCancel">取消</button>
                <button type="button" class="van-picker__confirm" @click="onScreenConfirm">确认</button>
              </div>
              <div class="picker_content">
                <div class="pickerBox">
                  <div class="picker_block" :class="{'activeBg': tempLiveScreenValue == item.Value}" v-for="(item, index) in liveScreenList" :key="index" @click="selectLiveScreen(item.Value)">{{item.Name}}</div>
                </div>
              </div>
            </div>
          </van-popup>
        </div>
        <weekly-calendar bgcolor="#FFFFFF" :calendarCode="liveScreenValue" @activeDate="activeDate" :key="calendarKey"></weekly-calendar>
      </div>

      <div class="liveWrapper" v-if="LiveList.length > 0">
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions" :key="swiperNonce">
          <swiper-slide class="swiper-slide" v-for="(item, index) in LiveList" :key="index" :data-id="item.Id">
              <div class="liveStatu" v-if="item.LiveStatus == 1 || item.LiveStatus == 2">
                <template v-if="item.LiveStatus == 1">
                  <img class="live_icon" src="@/assets/images/live_icon.png" />
                  <span>进行中</span>
                </template>
                <countdown v-if="item.LiveStatus == 2 && item.StartTime" :time="item.StartTime" :key="item.Id"></countdown>
              </div>
              <div class="viewmore" v-if="LiveList.length > 1">
                <span>滑动查看</span>
                <img src="@/assets/images/viewmore.png" />
              </div>
              <div class="liveTitle van-multi-ellipsis--l2">{{ item.Title }}</div>
              <div class="liveTime"><span>{{ item.StartTime | timeQuantum(item.EndTime) }}</span></div>
              <div class="WatchCount">
                <img src="@/assets/images/watch.png" />
                <span>{{ item.WatchCount }}</span>
              </div>
          </swiper-slide>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
      </div>

      <div class="listContainer" :style="{'marginBottom': list.length > 0 ? '0px' : '20px'}">
        <div class="home_classify">
          <div class="home_classify_content">
            <div class="home_classify_item" :class="{'home_classify_item_active': ModuleType == 1}" @click="selectClassify(1)">
              <div class="classifyIcon">
                <img class="classifyIcon1" src="@/assets/images/new_icon.png" />
              </div>
              <div class="classifyTitle">
                <template v-if="userInfo.Type != 3">最新</template>
                <template v-if="userInfo.Type == 3">New</template>
              </div>
            </div>
            <div class="home_classify_item" :class="{'home_classify_item_active': ModuleType == 2}" @click="selectClassify(2)">
              <div class="classifyIcon">
                <img class="classifyIcon2" src="@/assets/images/hot_icon.png" />
              </div>
              <div class="classifyTitle">
                <template v-if="userInfo.Type != 3">最热</template>
                <template v-if="userInfo.Type == 3">Hot</template>
              </div>
            </div>
          </div>
          <!-- <div class="screenBtn" @click="showDepartment">
            <span>科室筛选</span>
            <img src="@/assets/images/screen.png" />
          </div> -->
          <!-- <div class="screenTips" v-if="homeTipsShow">
            <span>点击按钮，选择您想要的科室内容</span>
            <img @click="closeTips" src="@/assets/images/delete_home_icon@2x.png" />
          </div> -->
          <van-popup v-model="showDepartmentPicker" round position="bottom" :style="{ height: '50%' }">
            <div class="pickerContent">
              <div class="van-picker__toolbar toolbar">
                <button type="button" class="van-picker__cancel" @click="onDepartmentCancel">取消</button>
                <button type="button" class="van-picker__confirm" @click="onDepartmentConfirm">确认</button>
              </div>
              <div class="picker_content">
                <div class="pickerBox">
                  <div class="picker_block" :class="{'activeBg': tempDepartmentTCcode == item.TCcode}" v-for="(item, index) in DepartmentColumns" :key="index" @click="selectDepartment(item.TCcode)">{{item.Name}}</div>
                </div>
              </div>
            </div>
          </van-popup>
        </div>
        <div id="dataList">
          <waterfall ref="waterfall" :col="2" :gutterWidth="10" :data="list">
            <template>
              <div class="list" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
                <div class="item_img">
                  <img class="item_cover" :src="item.Thumbnail" />
                  <img class="playIcon" v-if="item.Type == 1 || item.Type == 3" src="@/assets/images/play_icon.png" />
                </div>
                <div class="item_content">
                  <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
                  <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                    {{item.Speaker}} <span v-if="item.HospitalName">|</span> {{item.HospitalName}}
                  </div>
                  <!-- <div class="item_flexbox">
                    <p class="item_time">{{item.yyyymmdd}}</p>
                    <div class="item_nums">
                      <div class="nums">
                        <img src="@/assets/images/browse_comm_icon@2x.png" />
                        <span>{{item.WatchCount}}</span>
                      </div>
                      <div class="nums">
                        <img src="@/assets/images/like_comm_icon@2x.png" />
                        <span>{{item.LikeCount}}</span>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </template>
          </waterfall>
        </div>
      </div>
    </div>
    </div>
    </mescroll-vue>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import { mapState, mapMutations } from 'vuex'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import WeeklyCalendar from '../../components/weeklyCalendar.vue'
import Countdown from '../../components/countdown.vue'

export default {
  name: 'Home',
  data() {
    return {
      scroll: null,
      bannerList: [],
      liveShow: true,
      liveSwiperOptons: {
        pagination:{
          el:'.swiper-pagination',
          clickable:true,
        },
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10
      },
      showDepartmentPicker: false,
      DepartmentColumns: [],
      tempDepartmentTCcode: '',
      ModuleType: 1,
      LiveList: [],
      list: [],
      PageIndex: 0,
      PageSize: 6,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			},
      showScreenPopover: false,
      liveScreenList: [],
      tempLiveScreenValue: '',
      liveScreenValue: '',
      weeklyCalendarDate: '',
      calendarKey: '',
      swiperOptions: {
        effect: 'cards',
        cardsEffect: {
          slideShadows: false
        },
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          click: (swiper, event) => {
            let live = this.LiveList[swiper.realIndex];
            this.$router.push({
              path: 'liveDetails',
              query: {
                id: live.Id
              }
            });
          },
        },
      }
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    WeeklyCalendar,
    Countdown
  },
  watch: {
    navBar() {
      this.$nextTick(() => {
        this.scroll.refresh();
      })
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    if(this.userInfo && this.userInfo.Id) {
      this.getNavbar();
    }

    let date = new Date();
    this.weeklyCalendarDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.getBanner();
    // this.getDepartment();
    // this.getScreen();
    this.$store.commit('changeNavbarIndex', 0);
  },
  mounted() {
    this.getLiveList();
    this.initBScroll();
  },
  activated(){
    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '首页',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/home?sourceType=7')}`,
          contentId: ''
        }
      }
    })

    this.BuriedPoint(6, '首页', 'HomePage', '/home', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');

    this.mescroll.setBounce(false);
    this.mescroll.scrollTo(this.mescroll.preScrollY, 0);
    this.$store.commit('changeNavbarIndex', 0);
    this.showScreenPopover = false;
  },
  deactivated() {
    this.mescroll.setBounce(true);
  },
  methods: {
    ...mapMutations(['changeHomeTipsShow']),
    // 初始化BScroll
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    closeTips() {
      this.changeHomeTipsShow(false);
    },
    // 获取Banner
    getBanner() {
      this.$axios.get('/Api/api/Web/ImgFile/GetImgFileListByCode?Code=HomePage').then(res => {
        this.bannerList = res.Data;
      })
    },
    // 获取直播筛选项
    getScreen() {
      this.$axios.post('/Api/Api/Web/Article/GetScreen', {
        state: "",
        end: ""
      }).then((res) => {
        this.liveScreenList = res.Data.sird;
      })
    },
    // 获取科室
    getDepartment() {
      const url = this.userInfo.Type != 3 ? '/Api/Api/Web/Customer/GetDitWebCode?type=1&pcode=' : '/Api/Api/Web/Customer/GetDitWebCode?type=6&pcode='
      this.$axios.post(url).then(res => {
        this.DepartmentColumns = res.Data;
      })
    },
    showScreen() {
      this.showScreenPopover = true;
      this.tempLiveScreenValue = this.liveScreenValue;
    },
    // 直播筛选取消选择科室
    onScreenCancel() {
      this.showScreenPopover = false;
      this.tempLiveScreenValue = '';
    },
    // 直播筛选确认选择科室
    onScreenConfirm() {
      this.showScreenPopover = false;
      this.liveScreenValue = this.tempLiveScreenValue;
      this.calendarKey = new Date().getTime();
      this.getLiveList();
    },
    // 显示科室选中picker框
    showDepartment() {
      this.showDepartmentPicker = true;
      this.tempDepartmentTCcode = this.DepartmentTCcode;
    },
    // 取消选择科室
    onDepartmentCancel() {
      this.showDepartmentPicker = false;
      this.tempDepartmentTCcode = '';
    },
    // 确认选择科室
    onDepartmentConfirm() {
      this.showDepartmentPicker = false;
      this.DepartmentTCcode = this.tempDepartmentTCcode;
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    // 选择科室
    selectDepartment(TCcode) {
      if(this.tempDepartmentTCcode == TCcode) {
        this.tempDepartmentTCcode = '';
      } else {
        this.tempDepartmentTCcode = TCcode;
      }
    },
    // 获取列表数据
    getLiveList() {
      this.$axios.post('/Api/Api/Web/Article/GetLiveArticleList', {
        time: this.weeklyCalendarDate,
        code: this.liveScreenValue
      }).then(res => {
        this.LiveList = res.Data.slice(0, 10);
        let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = chars.length;
        let swiperNonce = '';
        for (let i = 0; i < 6; i++) {
          swiperNonce += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        if(this.LiveList.length > 1) {
          this.swiperOptions.loop = true;
          this.swiperNonce = swiperNonce;
        } else {
          this.swiperOptions.loop = false;
          this.swiperNonce = swiperNonce;
        }
      })
    },
    // 获取列表数据
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetArticleList', {
          SubjectTCode: this.DepartmentTCcode,
          ModuleType: this.ModuleType,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          IsShowLive: false
        }).then((res) => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    // 加载对应分类下的list
    selectClassify(type) {
      if(this.ModuleType != type) {
        this.ModuleType = type;
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      }
    },
    toDepartment(id, code, tcode, name) {
      let url = `/department?code=${code}&code=${this.code}`;
      this.BuriedPoint(1, name, tcode, url);
      this.$router.push({
        path: 'department',
        query: {
          id: id,
          code: code
        }
      })
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type
          }
        });
      }
    },
    imgclick(info) {
      if(info.LinkType && info.UrlLink) {
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.UrlLink)) {
            location.href = info.UrlLink;
          } else {
            this.$router.push(info.UrlLink);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.UrlLink})
        } else if(info.LinkType == 3) {
          if (info.UrlLink.indexOf('?') !== -1) {
            info.UrlLink += '&sourceType=3&sourceId=' + info.Id;
          } else {
            info.UrlLink += '?sourceType=3&sourceId=' + info.Id;
          }
          this.$router.push(info.UrlLink);
        }
      }
      this.BuriedPoint(3, '首页', info.DepartmentCode, info.UrlLink, info.Id);
    },
    selectLiveScreen(val) {
      if(this.tempLiveScreenValue == val) {
        this.tempLiveScreenValue = '';
      } else {
        this.tempLiveScreenValue = val;
      }
    },
    activeDate(date) {
      if(this.weeklyCalendarDate != date) {
        this.weeklyCalendarDate = date;
        this.getLiveList();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
  .headerBox {
    padding-top: 16px;
    background-color: #EB1701;
  }
  .mescroll {
    position: fixed;
    top: 0;
    bottom: 60px;
    height: auto;
  }
  .top {
    margin-bottom: 10px;
    display: flex;
    padding: 0 12px;
    .menuIcon {
      width: 30px;
      height: 30px;
    }
    .searchBox {
      display: flex;
      align-items: center;
      flex: 1;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      background-color: #FFFFFF;
      padding: 0 12px;
      .searchIcon {
        width: 16px;
        height: 16px;
      }
      .searchInput {
        flex: 1;
        margin-left: 5px;
        border: none;
        background-color: transparent;
        color: #999999;
      }
    }
  }
  .classify {
    display: flex;
    color: #FFFFFF;
    height: 31px;
    padding: 0 12px;
    .classify_content {
      display: flex;
      flex: 1;
      font-size: 14px;
      overflow: hidden;
      .classify_wrapper {
        white-space: nowrap;
        span {
          position: relative;
        }
        span:not(:last-child) {
          margin-right: 20px;
        }
        .active_classify {
          font-size: 18px;
          font-weight: bold;
        }
        .active_classify::after {
          content: "";
          width: 22px;
          height: 3px;
          border-radius: 3px;
          background-color: #FFFFFF;
          position: absolute;
          top: 24px;
          left: 50%;
          transform: translateX(-11px);
        }
      }
    }
    .more {
      font-size: 12px;
      margin-left: 10px;
      a {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        margin-top: 6px;
      }
      .addIcon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      span {
        opacity: 0.8;
      }
    }
  }
  .content {
    min-height: 100%;
    margin-top: 1px;
    padding: 12px 12px 0;
    background-color: #F9F9F9;
  }
  .content:before{
    content: '';
    display: table;
  }
  .banner {
    margin: 3px 0 15px 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    overflow: hidden;
    .bannerImg {
      width: 100%;
      display: block;
    }
  }
  .live_conference {
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 15px;
    margin-top: 15px;
    .live_title {
      display: flex;
      justify-content: space-between;
      color: #CA001B;
      .live_title_text {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
        img {
          width: 12px;
          height: 6px;
          margin-left: 7px;
        }
        .rotate {
          transform: rotate(180deg);
        }
      }
      .live_more {
        display: flex;
        align-items: center;
        font-size: 12px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 4px;
        }
      }
    }
    .live_content {
      position: relative;
      // height: 90px;
      margin-top: 10px;
      overflow: hidden;
      .live_cover {
        width: 100%;
        // height: 76px;
      }
      .live_status {
        position: absolute;
        top: 5px;
        left: 5px;
        display: inline-block;
        height: 15px;
        line-height: 15px;
        border-radius: 15px;
        padding: 0 6px;
        font-size: 9px;
        color: #FFFFFF;
        background-color: #000000;
        opacity: 0.5;
      }
    }
  }
  .liveBox {
    position: relative;
    box-sizing: border-box;
    padding: 8px 12px 10px;
    background-color: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    .screenBox {
      position: absolute;
      top: 9px;
      right: 12px;
    }
    .screenBtn {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #CA001B;
      img {
        width: 12px;
        height: 12px;
        margin-left: 3px;
      }
    }
  }
  .liveWrapper {
    margin-bottom: 15px;
    overflow: hidden;
    padding: 5px 25px;
    .swiper-slide {
      position: relative;
      height: 90px;
      background-color: #FFFFFF;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
      border-radius: 8px;
      padding: 5px;
      .liveStatu {
        display: flex;
        align-items: center;
        position: absolute;
        left: 0;
        top: 3px;
        height: 18px;
        line-height: 18px;
        border-radius: 0 18px 18px 0;
        // background-color: #CA001B;
        background: linear-gradient(to right, #D60300 0%, #EB1700 50%, #D60300 100%);
        color: #FFFFFF;
        font-size: 10px;
        padding: 0 10px;
        .live_icon {
          display: block;
          width: 10px;
          margin-right: 2px;
        }
      }
      .viewmore {
        position: absolute;
        top: 5px;
        right: 8px;
        display: flex;
        align-items: center;
        color: #CA001B;
        font-size: 10px;
        img {
          width: 15px;
          flex-shrink:0;
          margin-left: 3px;
        }
      }
      .liveTitle {
        margin: 18px 15px 0;
        font-size: 14px;
        font-weight: bold;
      }
      .liveTime {
        text-align: center;
        margin-top: 5px;
        span {
          display: inline-block;
          height: 16px;
          line-height: 16px;
          border-radius: 16px;
          padding: 0 10px;
          background-color: #CA001B;
          color: #FFFFFF;
          font-size: 11px;
        }
      }
      .WatchCount {
        display: flex;
        align-items: center;
        position: absolute;
        right: 10px;
        bottom: 8px;
        font-size: 11px;
        color: #564C47;
        img {
          width: 14px;
          margin-right: 2px;
        }
      }
    }
  }
  .listContainer {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 5px;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .home_classify {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 5px 0 10px;
    .home_classify_content {
      display: flex;
      align-items: flex-end;
      .home_classify_item {
        display: flex;
        align-items: center;
        width: 80px;
        height: 22px;
        border-radius: 22px;
        margin-right: 10px;
        padding: 1px;
        box-sizing: border-box;
        background: linear-gradient(135deg, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
        div {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 1;
        }
        .classifyIcon {
          img {
            display: block;
            margin-left: 2px;
          }
          .classifyIcon1 {
            width: 16px;
          }
          .classifyIcon2 {
            width: 13px;
          }
        }
        .classifyTitle {
          border-radius: 0 22px 22px 0;
          background-color: #FFFFFF;
          font-size: 12px;
          color: #CA001A;
        }
      }
      .home_classify_item_active {
        width: 90px;
        height: 25px;
        border-radius: 25px;
        padding: 0;
        .classifyIcon {
          img {
            display: block;
            margin-left: 2px;
          }
          .classifyIcon1 {
            width: 19px;
          }
          .classifyIcon2 {
            width: 15px;
          }
        }
        .classifyTitle {
          border-radius: 0 22px 22px 0;
          background-color: transparent;
          font-size: 14px;
          color: #FFFFFF;
          border-left: 1px solid #FFFFFF;
        }
      }
    }
    .screenBtn {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #CA001B;
      img {
        width: 12px;
        height: 12px;
        margin-left: 3px;
      }
    }
    .screenTips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      right: -2px;
      bottom: 40px;
      z-index: 99;
      width: 66%;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      padding: 0 15px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.75);
      font-size: 12px;
      color: #FFFFFF;
      img {
        width: 10px;
        height: 10px;
      }
    }
    .screenTips:before{
      content: "";
      width: 0px;
      height: 0px;
      border-top: 8px solid rgba(0, 0, 0, 0.75);
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      position: absolute;
      top: 30px;
      right: 9px;
    }
  }
  .picker_content {
    padding: 20px 6px;
    .pickerBox {
      display: flex;
      flex-wrap: wrap;
    }
    .picker_block {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(calc(100% / 3) - 12px);
      height: 36px;
      text-align: center;
      border: 1px solid rgba(153, 153, 153, 0.5);
      box-sizing: border-box;
      margin: 6px;
      border-radius: 4px;
      color: #333333;
      font-size: 14px;
    }
    .activeBg {
      border: none;
      color: #C70C3C;
      background-image: url('../../assets/images/select_system_btn@2x.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .list {
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 10px;
    .item_img {
      position: relative;
      .item_cover {
        display: block;
        width: 100%;
      }
      .playIcon {
        position: absolute;
        right: 3px;
        bottom: 3px;
        width: 20px;
        height: 20px;
      }
    }
    .item_content {
      padding: 5px 8px;
      background-color: #F9F8F7;
      color: #564C47;
      .item_title {
        font-size: 14px;
      }
      .doctor_info {
        font-size: 11px;
        margin-top: 5px;
        span {
          color: #999999;
        }
      }
      .item_flexbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .item_time {
        font-size: 12px;
        line-height: 24px;
      }
      .item_label {
        display: flex;
        flex-wrap: wrap;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          border-radius: 2px;
          padding: 0 6px;
          margin-right: 6px;
          margin-bottom: 5px;
          background-color: rgba(255, 73, 98, 0.15);
          font-size: 11px;
          color: #CA001B;
        }
      }
      .item_nums {
        display: flex;
        justify-content: flex-end;
        .nums {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            margin: 0 2px 0 6px;
          }
          span {
            font-size: 11px;
          }
        }
      }
    }
  }
}

.screenItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 132px;
  height: 32px;
  // line-height: 32px;
  font-size: 13px;
  color: #333333;
  padding: 0 12px;
  img {
    width: 12px;
    height: 12px;
  }
}
.liveScreenActive {
  color: #CA001B;
}
.iconLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 120px;
  right: 8px;
  .iconBox {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 3px;
  }
  img {
    width: 40px;
    height: 40px;
  }
  span {
    font-size: 10px;
    color: #CA001B;
  }
}

/deep/ .swiper-pagination-bullet-active {
  background: linear-gradient(to right, #EB1700 60%, #C33BBB 80%, #8C3BBB 100%) !important;
}

/deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 3px;
  border-radius: 3px;
  background-color: #999999;
  margin: 0;
}

/deep/ .swiper-pagination-bullets {
  bottom: 0px;
}

/deep/ .van-swipe__indicators {
  bottom: 5px;
}

/deep/ .van-popover--light {
  height: 100px !important;
  overflow: scroll !important;
}
</style>